/**
 * Guardas e mensagens COMPARTILHADAS pelas classes de API deste módulo.
 *
 * `requireId` e `ERRO_INESPERADO` nasceram copiados byte a byte em seis
 * arquivos (apiMetricasIa, apiSkillsGestao, apiAprendizado, apiKnowledge,
 * apiAcoesIa, apiAdvisory) — a copy do erro mudaria num e não nos outros.
 * Sem import de `APITemplate`: a guarda devolve o envelope pronto, no shape
 * `{ status, message, value }` que o `$showSnack` lê.
 */

/** Erro genérico com a próxima ação (regra "Mensagens de Erro: Sempre Incluem a Solução"). */
export const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

export const ERRO_ID_OBRIGATORIO = 'id obrigatório'

/**
 * Envelope 400 quando o `id` está ausente, ou `null` quando pode seguir.
 * `0` é id válido — só `undefined`/`null`/`''` barram.
 *
 *   const guard = requireId(id)
 *   if (guard) return guard
 */
export function requireId(id) {
  if (id === undefined || id === null || id === '') {
    return { status: 400, message: ERRO_ID_OBRIGATORIO, value: null }
  }
  return null
}
